var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center p-3 m-3"},[_vm._v("Oops! 404 Error")]),_c('div',{staticClass:"bc text-center p-3"},[_c('h3',[_vm._v(" Page Not Found. Go back to "),_c('router-link',{attrs:{"to":{ name: 'landing' }}},[_vm._v("Home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }